import { Injectable } from '@angular/core';
import {Http, Response} from "@angular/http";
import {ParentService} from "../ParentClass/ParentService";
import {constant} from "../../../app.constants";
import {Observable} from "rxjs";

@Injectable()
export class CropperService extends ParentService{

  constructor(
    private _http: Http
  ) {
    super()
  }

  public updateSignature(data) {
    return this._http.put(constant.URL_SIGNATURE_TRIP, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/cropper/cropper.service.ts